/* Block navigation to price-0 products (free gifts + bundle parent merge target).
   Links are marked server-side with `.pdp-link-locked`. Capture phase so this runs
   before the theme's data-instant click handler. Document-level + delegated so it
   survives cart-drawer re-renders. */
document.addEventListener('click', function (e) {
  if (e.target.closest('a.pdp-link-locked')) {
    e.preventDefault();
  }
}, true);
